export default __webpack_public_path__ + "static/media/assign-modules.eaceb1c4.png";